import {User} from "../models/users/User";

export enum Currency {
    EURO = "EUR",
    DOLLAR = "USD"    
}

export enum Locale {
    BRITAIN = "en-GB",
    GERMANY = "de-DE",
    USA = "en-US",
}

export const DateFormat = "dd.MM.yyyy";

export const DateTimeFormat = "dd.MM.yyyy HH:ii";

/**
 * converts a number string into a number format and returns an localized string
 * @param {string} value
 * @param {string} currency
 * @param {string} locale
 * @return {string}
 */
export function formatNumberCurrency( value: string | number, currency: Currency, locale: Locale ) {
    return Number(value).toLocaleString( locale, { style: 'currency', currency: currency });
}

/**
 * formats a number value into money with the german format and Currency Euro
 * @param value
 */
export function formatMoneyEuro( value: string | number ): string {
    return  Number(value).toLocaleString(
        Locale.GERMANY,
        { style: 'currency', currency: Currency.EURO }
    );
}

/**
 * formats a number in german number format.
 * @param {string} value
 * @param {string} locale
 *  @return {string}
 */
export function formatNumber( value: string | number, locale: Locale ) {
    return Number(value).toLocaleString( locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * reverses number formatting, works for german formatted numbers and money
 * it converts the number to a database friendly string
 * @param {string} value number as a formatted string
 * @returns {string}
 */
export function reverseNumberFormat( value: string ) {
    /*let newValue = value;
    if( ( value.match(/,/g) || [] ).length > 1 ) {
        newValue = value.replace(',', '');
    }
    return newValue.replace( /\./g, '').replace(',', '.')*/

    return value.replace( ',', '.' );
}

